import { colors } from '../../../constants/styleConstants';

export const interactiveFilterStyle = {
  root: {
    width: '100%',
    minWidth: 150,
    height: 35,
    background: colors.white,

    '& .MuiInputBase-root': {
      height: 35,
      padding: '0px 0px 0px 8px',
    },

    '& .MuiAutocomplete-hasClearIcon': {
      paddingRight: '14 !important',
    },

    '& .MuiAutocomplete-input': {
      paddingLeft: 8,
      fontSize: 14,
    },

    '& .MuiInputLabel-outlined': {
      transform: 'translate(14px, 7px) scale(1)',
      height: 24,
      margin: '0 48px 0 0',
      fontFamily: 'Roboto',
      fontSize: 14,
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1.71',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      width: 'calc(100% - 20px)',
    },

    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      transform: 'translate(14px, -10px) scale(0.8)',
      height: 16,
      lineHeight: '1.33',
      color: colors.grey4,
    },

    '& .MuiInputLabel-outlined.MuiInputLabel-shrink.MuiFormLabel-filled': {
      color: colors.grey4,
    },

    '& :hover .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      color: colors.darkBlue,
    },

    '& .MuiInputLabel-outlined.MuiInputLabel-shrink.Mui-focused': {
      color: colors.darkBlue,
    },

    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: colors.darkBlue,
    },

    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: colors.darkBlue,
    },

    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: colors.fieldsBorderGray,
    },
  },
  clearIndicator: {
    marginRight: 10,
    padding: 0,
    fontSize: 11,
  },
  popperDesktop: {
    zIndex: 998,
  },
  popper: {
    '& .MuiAutocomplete-paper': {
      fontSize: 14,
      marginTop: '0 !important',
    },
  },
  inputRoot: {
    '&[class*="MuiOutlinedInput-root"]': {
      /* '$hasPopupIcon &, $hasClearIcon &': {
        paddingRight: 10,
      }, */

      '& .MuiAutocomplete-endAdornment': {
        right: 0,
      },
    },

    '&[class*="MuiFilledInput-root"]': {
      '& .MuiAutocomplete-endAdornment': {
        right: 0,
      },
    },
  },
  option: {
    '&[data-focus="true"]': {
      backgroundColor: colors.blue1,
    },

    '&[aria-selected="true"]': {
      backgroundColor: colors.blue1,
    },

    '&:active': {
      backgroundColor: colors.blue2,
    },
  },
};
